// extracted by mini-css-extract-plugin
module.exports = {"table":"drawable_table_table__n22eC","null":"drawable_table_null__BQkwv"};